"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
(function _() {
  var styles = ".Video {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n}\n.Video iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}";
  var fileName = "Video_Video";
  var element = document.querySelector("style[data-sass-component='Video_Video']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Video = function Video(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    youtubeEmbedURL = _ref.youtubeEmbedURL,
    title = _ref.title,
    metaThumbnailURL = _ref.metaThumbnailURL,
    metaDescription = _ref.metaDescription,
    metaUploadDate = _ref.metaUploadDate;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "Video ".concat(className),
    itemScope: true,
    itemType: "http://schema.org/VideoObject",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      itemProp: "name",
      content: title
    }), metaThumbnailURL && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      itemProp: "thumbnailURL",
      content: metaThumbnailURL
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      itemProp: "embedURL",
      content: youtubeEmbedURL
    }), metaDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      itemProp: "description",
      content: metaDescription
    }), metaUploadDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
      itemProp: "uploadDate",
      content: metaUploadDate
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
      width: "100%",
      height: "100%",
      src: youtubeEmbedURL
    })]
  });
};
var _default = Video;
exports["default"] = _default;